import React, { useEffect, useState } from 'react';
import { Input } from '../design-system';
import { useDebounce, usePrevious } from 'react-use';

interface SearchFilterProps {
  onFilter: (value: string) => void;
  initialValue?: string;
  [key: string]: any;
}

const SearchFilter = ({
  onFilter,
  initialValue = '',
  ...rest
}: SearchFilterProps) => {
  const [value, setValue] = useState(initialValue);
  const prevValue = usePrevious(initialValue);

  const handleChange = (_: any, newValue: string) => {
    setValue(newValue);
  };

  useDebounce(
    () => {
      onFilter(value);
    },
    300,
    [value],
  );

  useEffect(() => {
    if (!initialValue && prevValue) {
      setValue('');
    }
  }, [initialValue, prevValue]);

  return (
    <Input
      name="search"
      label="Search"
      onChange={handleChange}
      value={value}
      {...rest}
    />
  );
};

export default SearchFilter;
